import ActionRow from "../components/v2/ActionRow";
import ChoiceStack from "../components/v2/ChoiceStack";
import HelperLine from "../components/v2/HelperLine";
import PageTransition from "../components/v2/PageTransition";
import QuestionCounter from "../components/v2/QuestionCounter";
import QuestionLabel from "../components/v2/QuestionLabel";
import Wordmark from "../components/v2/Wordmark";
import "../components/v2/v2-question-surface.css";

export const SURFACE_8_LABEL = "How comfortable are they with technology?";
export const SURFACE_8_HELPER = "Pick the closest fit.";

export const TECH_COMFORT_OPTIONS = [
  {
    key: "avoids",
    title: "Avoids it if possible",
    explanation: "phones, computers, anything digital",
  },
  {
    key: "uses_reluctantly",
    title: "Uses it but doesn't love it",
    explanation: "gets things done, doesn't dig in",
  },
  {
    key: "comfortable",
    title: "Comfortable enough",
    explanation: "figures most things out",
  },
  {
    key: "builds_it",
    title: "They'd probably build this themselves",
    explanation: "actively into tech",
  },
];

export default function Surface8({
  value,
  direction = "forward",
  onChange,
  onBack,
  onNext,
  editMode = false,
}) {
  return (
    <section className="tgc-v2-surface tgc-v2-surface--choice" aria-labelledby="question-label">
      <PageTransition direction={direction}>
        <div className="tgc-v2-choice-shell">
          <div className="tgc-v2-choice-header">
            <Wordmark variant="stacked" />
            <QuestionCounter current={4} total={12} />
            <QuestionLabel>{SURFACE_8_LABEL}</QuestionLabel>
            <HelperLine id="surface-8-helper">{SURFACE_8_HELPER}</HelperLine>
          </div>

          <div className="tgc-v2-choice-scroll" aria-describedby="surface-8-helper">
            <ChoiceStack
              options={TECH_COMFORT_OPTIONS}
              value={value}
              behavior="single-select"
              autoAdvance={!editMode}
              ariaLabel="Technology comfort options"
              onChange={onChange}
              onAutoAdvance={onNext}
            />
          </div>

          <div className="tgc-v2-choice-back">
            <ActionRow
              variant={editMode ? "done-only" : "back-only"}
              onBack={onBack}
              onNext={onNext}
              nextDisabled={!value}
              nextLabel="Done"
            />
          </div>
        </div>
      </PageTransition>
    </section>
  );
}
